import { FormInstance } from 'antd'
import CurrencyService from '../service/CurrencyService'
import RegionService from '../service/RegionService'

// Sample values for the generic fields of the create forms. Target ids (accounts, users) are never sampled,
// they have to exist in the environment

const names = ['Alex Tan', 'Priya Nair', 'Daniel Lim', 'Siti Rahma', 'Kenji Sato', 'Maria Santos']
const regionCurrencies: Record<string, string> = { SG: 'SGD', ID: 'IDR', HK: 'HKD', MY: 'MYR' }
// A real bank in each region; the collection form derives the sender bank country from the BIC
const regionBics: Record<string, string> = { SG: 'DBSSSGSG', ID: 'CENAIDJA', HK: 'DHBKHKHH', MY: 'MBBEMYKL' }

const pick = <T>(items: T[]): T => items[Math.floor(Math.random() * items.length)]
const digits = (length: number) => Array.from({ length }, () => Math.floor(Math.random() * 10)).join('')

export const currencyFor = (region: string): string => {
    const currency = regionCurrencies[region]
    const known = [...CurrencyService.mostUsedCurrencies, ...CurrencyService.allCurrencies]
    return currency && known.includes(currency) ? currency : 'USD'
}

export const sampleReference = () => `SIM-${Date.now().toString(36).toUpperCase()}`

const sampleAmount = () => pick([100, 250, 1000, 1500.5, 5000])

export const collectionSample = () => ({
    senderName: pick(names),
    senderAccountNumber: digits(10),
    senderBankBIC: regionBics[RegionService.get()] ?? regionBics.SG,
    amount: sampleAmount(),
    currency: currencyFor(RegionService.get()),
    method: 'local',
    customerReference: sampleReference(),
})

export const fundingSample = (fundingMethod?: string) => ({
    amount: sampleAmount(),
    currencyId: currencyFor(RegionService.get()),
    fundingMethod: fundingMethod ?? 'BANK_TRANSFER',
    // A refund references real simple payments, so only sample a plain reference
    ...(fundingMethod === 'REFUND' ? {} : { reference: sampleReference() }),
})

export const deductionSample = () => ({
    amount: sampleAmount(),
    currencyId: currencyFor(RegionService.get()),
    deductionType: 'adjustment',
    remarks: 'Simulated deduction',
})

const isEmpty = (value: unknown) => value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)

// Fills only the fields the user hasn't filled in yet
export const fillEmpty = (form: FormInstance, sample: Record<string, unknown>) => {
    const current = form.getFieldsValue(true) as Record<string, unknown>
    form.setFieldsValue(Object.fromEntries(Object.entries(sample).filter(([field]) => isEmpty(current[field]))))
}
